import React, { useState } from 'react';
import { RightArrow } from '../../assets/svg/ArrowIcon';
import { useSelector } from 'react-redux';
import { RootState } from '@rb-serve-app/core';
import moment from 'moment';

type MessageCardProps = {
  message: any;
  isSelected: boolean;
  onClick: () => void;
};

const MessageCard: React.FC<MessageCardProps> = ({
  message,
  isSelected,
  onClick,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const { contentfulData } = useSelector(
    (state: RootState) => state.contentful
  );
  const { entries, assets } = contentfulData || {};
  const { rb_secure_message, rb_change_password } = entries || {};
  const { secureMessageListInfo, secureMessageErrorInfo } = rb_secure_message;
  console.log('rb_secure_message', rb_secure_message);

  const getDisplayStatus = (status: string) => {
    if (!status) return '';

    switch (status.toUpperCase()) {
      case 'APPROVED':
        return `${secureMessageErrorInfo?.complete}`;
      case 'PENDING':
        return `${secureMessageErrorInfo?.submitted}`;
      default:
        return `${secureMessageErrorInfo?.submitted}`;
    }
  };
  const setupLocale = () => {
    try {
      const deviceLocale = localStorage.getItem('language');
      const localeToUse = deviceLocale === 'fr' ? 'fr' : 'en';

      moment.locale(localeToUse);

      return localeToUse;
    } catch (error) {
      console.warn('Error setting moment locale:', error);
      moment.locale('en');
      return 'en';
    }
  };
  const locale = setupLocale();
  return (
    <button
      onClick={onClick}
      aria-pressed={isSelected}
      onTouchStart={() => setIsHovered(true)}
      onTouchEnd={() => setTimeout(() => setIsHovered(false), 1000)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={` relative text-left w-full p-4 border rounded-lg focus:outline-none focus-visible:ring-2 ring-blue-600 ${
        isSelected ? 'border-primary-red' : 'border-gray-200'
      }`}
    >
      <p className="text-[16px] md:text-[14px] lg:text-[14px] xl:text-[16px] text-black">
        {moment(message.requestDate).locale(locale).format('ddd, MMMM D, YYYY')}
        {/* {new Date(message.requestDate).toDateString()} */}
      </p>
      <div className="flex md:gap-[3rem] gap-[12px] items-center">
        <div className="mt-[2px]">
          <p className="font-[650] text-[16px] md:text-[14px] lg:text-[14px] xl:text-[16px] leading-6">
            {rb_secure_message?.confirmationNumber}
          </p>
          <p className="text-[16px] md:text-[14px] lg:text-[14px] xl:text-[16px] text-black mt-[2px]">
            {message.confirmationNumber}
          </p>
        </div>
        <div>
          <p className="font-[650] text-[16px] md:text-[14px] lg:text-[14px] xl:text-[16px] leading-6">
            {rb_secure_message?.secureMessageErrorInfo?.status}
          </p>
          <p
            className={`text-[16px] md:text-[14px] lg:text-[14px] xl:text-[16px] mt-[2px] ${
              message.status === 'COMPLETED'
                ? 'text-green-600'
                : 'text-primary-red'
            }`}
          >
            {getDisplayStatus(message.status)}
          </p>
        </div>
      </div>
      {isHovered && (
        <span className="absolute block md:hidden top-[40%] right-[5px]">
          <RightArrow width="24px" height="24px" fill="#DA291C" />
        </span>
      )}
    </button>
  );
};

export default MessageCard;
